import React from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
// utils
import {
  getModulePath,
  getDailyAccess,
  getWeeklyAccess,
  getMonthlyAccess,
  getSkillsAccess,
  getSubscriptionAccess,
} from './utils';
// components
import { Switch, Redirect, withRouter } from 'react-router-dom';
import AuthorizedRoute from '../../layouts/routes/AuthorizedRoute';
import PublicRoute from '../../layouts/routes/PublicRoute';
// containers
import Profile from '../UserProfile/UserProfile';
import Congratulation from '../Congratulation/Congratulation';
import LogIn from '../LogIn/LogIn';
import Help from '../Help/Help';
import PasswordRecovery from '../PasswordRecovery/PasswordRecovery';
import PasswordReset from '../PasswordReset/PasswordReset';
import SignUp from '../SignUp/SignUp';
import Logout from '../Logout/Logout';
import Dashboard from '../Dashboard/Dashboard';
import Resources from '../Resources/Resources';
import Page404 from '../Page404/Page404';
import Module from '../Module/Module';
import Skills from '../Skills/Skills';
import Journal from '../Journal/Journal';
import RecoveryPlan from '../RecoveryPlan/RecoveryPlan';
import MonthlyCheckIn from '../MonthlyCheckIn/MonthlyCheckIn';
import WeeklyCheckIn from '../WeeklyCheckIn/WeeklyCheckIn';
import DailyCheckIn from '../DailyCheckIn/DailyCheckIn';
import Billing from '../Billing/Billing';
// static pages
import SupportPage from '../SupportPage/SupportPage';
import TermsConditions from '../TermsConditions/TermsConditions';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import About from '../About/About';

const Routes = ({ user }) => {
  const modulePath = getModulePath(user);
  const hasSubscription = getSubscriptionAccess(user);

  return (
    <Switch>
      {/* Authorized */}
      <AuthorizedRoute
        exact
        path="/:type(recovery-plan)?"
        background="profile"
        backLink="/dashboard"
        dashboardMenu={false}
        component={RecoveryPlan}
      />
      <AuthorizedRoute
        path="/profile"
        component={Profile}
        background="profile"
        blobs
      />
      <AuthorizedRoute
        path="/dashboard"
        component={Dashboard}
        dashboardMenu={false}
      />

      {/* Authorized: Client only */}
      <AuthorizedRoute
        clientOnly
        path="/congratulation"
        component={Congratulation}
        background="congrats"
        // locked={!hasSubscription}
      />
      <AuthorizedRoute clientOnly path="/help" blobs component={Help} />
      <AuthorizedRoute
        clientOnly
        blobs
        path="/resources/:type(articles|worksheets|saved|recovery)?"
        component={Resources}
      />
      <AuthorizedRoute clientOnly path={modulePath} component={Module} />
      <AuthorizedRoute
        clientOnly
        locked={!getSkillsAccess(user) || !hasSubscription}
        path="/skills/:mode(edit)?"
        background="profile"
        backLink="/dashboard"
        dashboardMenu={false}
        component={Skills}
      />
      <AuthorizedRoute
        clientOnly
        locked={!hasSubscription}
        path="/journal/:type(prompts)?"
        background="profile"
        backLink="/dashboard"
        dashboardMenu={false}
        component={Journal}
      />
      <AuthorizedRoute
        clientOnly
        locked={!getMonthlyAccess(user) || !hasSubscription}
        path="/monthly-check-in"
        background="profile"
        backLink="/dashboard"
        component={MonthlyCheckIn}
      />
      <AuthorizedRoute
        clientOnly
        locked={!getWeeklyAccess(user) || !hasSubscription}
        path="/weekly-check-in"
        background="profile"
        backLink="/dashboard"
        component={WeeklyCheckIn}
      />
      <AuthorizedRoute
        clientOnly
        locked={!getDailyAccess(user) || !hasSubscription}
        path="/daily-check-in"
        background="profile"
        backLink="/dashboard"
        component={DailyCheckIn}
      />
      <AuthorizedRoute clientOnly blobs path="/billing" component={Billing} />
      {/* Public */}
      <PublicRoute exact path="/:type(login)?" component={LogIn} />
      <PublicRoute path="/signup" component={SignUp} />
      <PublicRoute
        path="/password-recovery"
        component={PasswordRecovery}
        background="grey"
      />
      <PublicRoute path="/password-reset" component={PasswordReset} />
      <PublicRoute path="/404" component={Page404} background="none" />
      <PublicRoute path="/logout" component={Logout} />

      <PublicRoute path="/support" component={SupportPage} blobs />
      <PublicRoute path="/terms" component={TermsConditions} blobs />
      <PublicRoute path="/privacy" component={PrivacyPolicy} blobs />
      <PublicRoute path="/about" component={About} blobs />
      <Redirect to="/404" />
    </Switch>
  );
};

const enhance = compose(
  withRouter,
  connect(state => ({ user: state.auth.user }))
);

export default enhance(Routes);



// WEBPACK FOOTER //
// ./src/containers/Routes/Routes.jsx